export function generateTransactionObject(src: any, dest: any): void {
  if (src.hasOwnProperty('orderItems')) {
    src.offers = src.orderItems;
    delete src.orderItems;
  }
  dest.transaction = src;
}
